import classNames from 'classnames/bind';

import styles from './Header.module.scss';
import images from '~/assets/images';
import Button from '~/components/Button';
import { DownIconHover, DownloadIcon, LeftAngleIcon, MenuIcon } from '../Icons/Icons';
import Nav, { NavItem } from './Nav';
import config from '~/config/config';
import { useState, useEffect } from 'react';

const cx = classNames.bind(styles);

function Header() {
    const handleDownload = () => {
        // const url = `/abc`; // thay đổi đường dẫn đến file PDF tại đây
        // const link = document.createElement('a');
        // link.href = url;
        // link.download = url.split('/').pop();
        // document.body.appendChild(link);
        // link.click();
        // document.body.removeChild(link);
        alert('Hì, mình chưa có viết CV');
    };

    const [active, setActive] = useState(false);

    useEffect(() => {
        window.addEventListener('scroll', () => {
            if (window.scrollY > 150) {
                setActive(true);
            } else {
                setActive(false);
            }
        });
        console.log('scrolled');
    }, []);

    const [isMobile, setIsMobile] = useState(false);

    function handleShowMenu() {
        setIsMobile(true);
    }

    function handleHideMenu() {
        setIsMobile(false);
    }

    const scrollToTop = () => {
        const c = document.documentElement.scrollTop || document.body.scrollTop;
        if (c > 0) {
            window.requestAnimationFrame(scrollToTop);
            window.scrollTo(0, c - c / 8);
        }
    };

    const aboutScroll = () => {
        const t = document.querySelector('#about');
        if (window.matchMedia('(max-width: 768px)').matches) {
            t.scrollIntoView({ block: 'start', behavior: 'smooth' });
        } else {
            t.scrollIntoView({ block: 'center', behavior: 'smooth' });
        }
    };

    const educationScroll = () => {
        const edu = document.querySelector('#education');
        edu &&
            edu.scrollIntoView({
                behavior: 'smooth',
                block: 'start',
            });
    };

    const portfolioScroll = () => {
        const p = document.querySelector('#portfolio');
        p &&
            p.scrollIntoView({
                behavior: 'smooth',
                block: 'start',
            });
    };

    const blogScroll = () => {
        const b = document.querySelector('#blog');
        b &&
            b.scrollIntoView({
                behavior: 'smooth',
                block: 'start',
            });
    };

    return (
        <div className={cx('wrapper', { active })}>
            <header className={cx('grid', 'wide', 'header')}>
                {/* For Mobile */}

                <div className={cx('m-nav-button')} onClick={handleShowMenu}>
                    <MenuIcon className={cx('icon')} />
                </div>

                <div className={cx('m-nav', { show: isMobile })}>
                    <div onClick={handleHideMenu}>
                        <LeftAngleIcon className={cx('icon')} />
                    </div>
                    <div className={cx('m-nav-content')}>
                        <Nav>
                            <div className={cx('m-nav-column')}>
                                <div className={cx('item')}>
                                    <NavItem title="Trang chủ" to={config.routes.home} onClick={scrollToTop} />
                                </div>
                                <div className={cx('item')}>
                                    <NavItem title="Giới thiệu" to={config.routes.about} onClick={aboutScroll} />
                                </div>
                                <div className={cx('item')}>
                                    <NavItem title="Học vấn" to={config.routes.education} onClick={educationScroll} />
                                </div>
                                <div className={cx('item')}>
                                    <NavItem title="Sản phẩm" to={config.routes.portfolio} onClick={portfolioScroll} />
                                </div>
                                <div className={cx('item')}>
                                    <NavItem title="Blog" to={config.routes.blog} onClick={blogScroll} />
                                </div>
                            </div>
                        </Nav>
                    </div>
                </div>

                <div>
                    <a href="/">
                        <img className={cx('image')} src={images.logo} alt="logo" />
                    </a>
                </div>

                <div className={cx('nav')}>
                    <Nav>
                        <NavItem title="Trang chủ" to={config.routes.home} onClick={scrollToTop} />
                        <NavItem title="Giới thiệu" to={config.routes.about} onClick={aboutScroll} />
                        <NavItem title="Học vấn" to={config.routes.education} onClick={educationScroll} />
                        <NavItem title="Sản phẩm" to={config.routes.portfolio} onClick={portfolioScroll} />
                        <NavItem title="Blog" to={config.routes.blog} onClick={blogScroll} />
                    </Nav>
                </div>
                <div className={cx('resume_download')}>
                    <Button
                        onClick={handleDownload}
                        primary
                        className={cx('resume-button')}
                        rightIcon={
                            <div>
                                <DownloadIcon className={cx('left-icon')} />
                                <DownIconHover className={cx('down-icon')} />
                            </div>
                        }
                    >
                        Resume
                    </Button>
                </div>
            </header>
        </div>
    );
}

export default Header;
